/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingSessions } from '../../models/charging-sessions';

export interface ApiChargingSessionsCompanyCodeGet$Plain$Params {
  companyCode: string;
}

export function apiChargingSessionsCompanyCodeGet$Plain(http: HttpClient, rootUrl: string, params: ApiChargingSessionsCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingSessions>> {
  const rb = new RequestBuilder(rootUrl, apiChargingSessionsCompanyCodeGet$Plain.PATH, 'get');
  if (params) {
    rb.path('companyCode', params.companyCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargingSessions>;
    })
  );
}

apiChargingSessionsCompanyCodeGet$Plain.PATH = '/api/ChargingSessions/{companyCode}';
